import React from "react";
import { useTranslation } from "react-i18next";

import { List, ListItem, ListIcon, Text, Box } from "@chakra-ui/react";
import { IoMdCloseCircle } from "react-icons/io";
import { MdCheckCircle, MdSettings } from "react-icons/md";

export default function StatementStatusTooltipLabel({ statementStatus }) {
	const { t } = useTranslation();
	const getListIcon = (status) => {
		switch (status) {
			case "warning":
				return <ListIcon as={MdSettings} color="yellow.500" />;
			case "complete":
				return <ListIcon as={MdCheckCircle} color="green.500" />;
			case "incomplete":
				return <ListIcon as={IoMdCloseCircle} color="red.500" />;
			case "expired":
				return <ListIcon as={IoMdCloseCircle} color="red.500" />;
			default:
				return <ListIcon as={IoMdCloseCircle} color="red.500" />;
		}
	};
	return (
		<Box>
			<Text fontSize="sm" fontWeight="bold">
				{t("table.statements")}
			</Text>
			<List spacing={3}>
				<ListItem>
					{getListIcon(statementStatus.c168)}
					C168
				</ListItem>
				<ListItem>
					{getListIcon(statementStatus.statement)}
					Declaratie
				</ListItem>
			</List>
		</Box>
	);
}
